import React from "react";

const PropertySuggestIcon = () => {
  return (
      <span className="suggest-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
        >
          <g fill="none" fillRule="evenodd">
            <rect width="40" height="40" fill="#E2EAF2" rx="8"></rect>
            <g transform="translate(10 11)">
              <path
                stroke="#2A69A3"
                strokeWidth="1.5"
                d="M6 0h8c.552 0 1 .448 1 1v18h0H5V1c0-.552.448-1 1-1zM15 8h4c.552 0 1 .448 1 1v9c0 .552-.448 1-1 1h-4 0V8zM1 6h4v13H1c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1z"
              ></path>
              <rect
                width="5"
                height="1.5"
                x="7.5"
                y="3"
                fill="#2A69A3"
                rx=".75"
              ></rect>
              <rect
                width="5"
                height="1.5"
                x="7.5"
                y="7"
                fill="#2A69A3"
                rx=".75"
              ></rect>
              <rect
                width="5"
                height="1.5"
                x="7.5"
                y="11"
                fill="#2A69A3"
                rx=".75"
              ></rect>
              <rect
                width="5"
                height="1.5"
                x="7.5"
                y="15"
                fill="#2A69A3"
                rx=".75"
              ></rect>
            </g>
          </g>
        </svg>
      </span>
  );
};

export default PropertySuggestIcon;
